import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';

const useStyles = createUseStyles({
  autocompleteTextResult: {
    padding: [8, 0, 8, 5],
  },
});

function AutocompleteTextResult(props) {
  const classes = useStyles();
  return (
    <div className={classes.autocompleteTextResult}>
      {props.prediction}
    </div>
  );
}

AutocompleteTextResult.propTypes = {
  prediction: PropTypes.string.isRequired,
};

export default AutocompleteTextResult;
